import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSubheader } from "../../../../_metronic/layout";
import { ReportParametersForm } from "../components/ReportParametersForm";
import { ReportTable } from "../components/ReportTable";
import { EodReportTable } from "../components/EodReportTable";


export const ReportManagement = () => {
  const subheader = useSubheader();
  subheader.setTitle("Reporting");

  return (
    <>
      <div className="row">
        <div className="col-12">
          <Switch>
            <Redirect
              from="/reporting"
              exact={true}
              to="/reporting/reporting-table"
            />
            <Route
              path="/reporting/reporting-table"
              component={ ReportTable }
            />
            <Route
              path="/reporting/report-parameter-form"
              component={ReportParametersForm}
            />
            <Route
              path="/reporting/end-of-day-report"
              component={EodReportTable}
            />
          </Switch>
      </div>
      </div>
    </>
  );
};
